// biome-ignore-all assist/source/useSortedKeys: manual sorting for this file is better for readability

const defaultFontURL =
  'https://fonts.googleapis.com/css2?family=Rubik:wght@400;500;600;700;800&display=swap';

const isDemoLocation = window.location.hostname.includes('localhost');

const socketBatchActions = {
  CREATE: 1,
  UPDATE: 2,
  DELETE: 3,
} as const;

export type TSocketBatchAction = (typeof socketBatchActions)[keyof typeof socketBatchActions];

// prefix for local storage keys in shadowRootMode
const shadowRootModePrefix = 'STSB_';

const betTrackMark = {
  default: 'default',
  expressTip: 'express-tip',
  quickBet: 'quick-bet',
  liveBet: 'live-bet',
  sharedBet: 'shared-bet',
  expressPresetBet: 'express-preset',
  betBuilderPresetBet: 'bet-builder-preset',
  tournamentPresetBet: 'express-preset-by-tournament',
  mixedTurboComboBet: 'mixed-turbo-combo',
  customEventPageBet: 'custom-event-page',
  customTournamentsPageBet: 'custom-tournaments-page',
  popularBetsWidget: 'popular-bet',
  betBuilder: 'bet-builder',
  topEventsLine: 'top-events',
  swipeBet: 'swipe-bet',
  personalizedEvents: 'personalized-events',
};

const fakeDemoPartnerCids: readonly string[] = ['black_demo'];

const minBoostOdd = 1.4;

const disciplineViewTypes = {
  0: 'ICON.VIEW.GRID', // Sort discipline items by Time
  1: 'ICON.VIEW.LIST', // Sort discipline items by Tournaments
};

const footballWorldCupViewTypes = {
  0: 'ICON.VIEW.GRID', // Sort discipline items by Time
  1: 'ICON.VIEW.GROUPS', // Sort discipline items by Groups
};

const ERROR_AUTO_CLEAR_TIMEOUT = 5000;

const expressMaxOdd = 10000;

const PLACE_BET_DEBOUNCE_TIME = 25;

// ids for custom tournament page
// TODO: after ends of tournament, please set to the "customTournamentPageId" constant to empty string
// TODO: it will stop som unnecessary calculations
const customTournamentPageId = ''; // 3303 921
const customTournamentPageOutrightIds = []; // спросить про аутрайты
const customTournamentPageDid = 'football';
const customTournamentPageName = 'euro-cup';
const customTournamentPageHeaderTitle = 'Euro 2024';
const customTournamentPageMenuTabName = 'UEFA Euro 2024';
const customTournamentPageStats = 'euro24';
const customTournamentPageLivePrematchLine = ['1', 'upcoming'];
const customTournamentPageRoute = `/${customTournamentPageDid}/${customTournamentPageName}`;
const customTournamentPageSlug = `${customTournamentPageDid}-${customTournamentPageName}`;

// ids for Olympic Games page
// TODO: after games are finished set constant "isShowOlympicGamesPage" to value "false"
// TODO: it will stop som unnecessary calculations
const isShowOlympicGamesPage = false;
const olympicGamesPageName = 'olympic-games';
const olympicGamesPageTitle = 'Olympic Games 2024';
const additionalDisciplinesForOlympicGames = ['entertainment'];
const olympicGamesTournamentsIdsForDisciplines = {
  football: ['15185', '255'],
  basketball: ['15246', '15247'],
  volleyball: ['15186', '15187'],
  tennis: ['18827', '18829'],
  tabletennis: ['15178', '15175'],
  handball: ['14393', '14394'],
  boxing: ['15397', '18837'],
  basketball3x3: ['18750'],
  'rugby-league': ['18763', '257'],
  'beach-volleyball': ['14342', '14341'],
};
const olympicGamesTournamentFilterLS = 'OGTF';
const olympicGamesLineFilterLS = 'OGLF';

// ids for Top Custom Tournament page
// TODO: after Top Custom Tournament are finished set constant "isShowTopCustomTournamentPage" to value "false"
// TODO: it will stop som unnecessary calculations

const isShowTopCustomTournamentPage = false;
const topCustomTournamentPageId = '';
const topCustomTournamentPageOutrightIds = []; // спросить про аутрайты
const topCustomTournamentPageDid = 'dota2';
const topCustomTournamentPageName = 'international';
const topCustomTournamentPageHeaderTitle = 'The International 2024';
const topCustomTournamentPageHeaderDiscipline = 'Dota 2';
const topCustomTournamentPageMenuTabName = 'The International 2024';
const topCustomTournamentPageIconName = 'dota2-International';
const topCustomTournamentPageRoute = `${topCustomTournamentPageDid}-${topCustomTournamentPageName}`;

// These ids have nothing to do with "custom tournament page", which are listed above,
// these ids just add the custom tournament link in nav menu.
// To display or hide this tournament in the nav menu, add the appropriate ids or leave the field values empty.
const navMenuCustomTournament = {
  tournamentId: '', // 4099
  tournamentDid: '', // dota2
};
const navMenuCustomTournamentLink = `/${navMenuCustomTournament.tournamentDid}/tournaments/${navMenuCustomTournament.tournamentId}`;

const footballWorldCupEventsIds = {
  11843337: 'A',
  11842572: 'B',
  11842578: 'A',
  12681613: 'B',
  11842612: 'C',
  11842610: 'D',
  11842635: 'C',
  12776851: 'D',
  11842686: 'F',
  11842688: 'E',
  14725783: 'E',
  11842636: 'F',
  11842705: 'G',
  11842729: 'H',
  11842687: 'H',
  11842689: 'G',
  12695954: 'B',
  11961484: 'A',
  11961712: 'A',
  //
  12836479: 'G',
  12836382: 'G',
  12836371: 'H',
  12836351: 'H',
  12835979: 'E',
  12835935: 'E',
  12836172: 'F',
  12800645: 'F',
  12835779: 'C',
  12835703: 'C',
  12835840: 'D',
  12780453: 'D',
  12835552: 'B',
  12696562: 'B',
  12835496: 'A',
  14517252: 'A',
  11963744: 'H',
  11963766: 'G',
  11963162: 'H',
  11963037: 'G',
  11963018: 'E',
  11962999: 'F',
  11962989: 'F',
  12818263: 'E',
  11962976: 'C',
  11962950: 'D',
  11962911: 'C',
  12780369: 'D',
  11962908: 'B',
};

const subscribeChain = {
  line: {
    nextModel: 'discipline',
    nextModelIds: 'disciplineIds',
  },
  discipline: {
    nextModel: 'tournament',
    nextModelIds: 'tournamentIds',
  },
  tournament: {
    nextModel: 'event',
    nextModelIds: 'eventIds',
  },
  event: {
    nextModel: 'market',
    nextModelIdsAlt: 'marketIds',
    nextModelIds: 'mainMarketIds',
  },
};

const disciplineCategoryAliases = {
  2: 'sport',
  1: 'eSport',
  3: 'vSport',
  4: 'racing',
};
const lineFilterToDisciplineCategories = {
  esport: 1,
  sport: 2,
  virtual_sport: 3,
  animal_racing: 4,
};

const pureOutrightsDisciplines = new Set(['politics', 'biathlon', 'entertainment']);

const animalsRacingDisciplines = new Set(['horse-racing', 'harness-racing', 'greyhound-racing']);

const footballDisciplines = ['football', 'efootball', 'efootball-bots'];

const vsportDisciplines = new Set([
  'ebasketball',
  'etennis',
  'ehockey',
  'emma',
  'efootball',
  'efootball-bots',
  'ebasketball-bots',
  'etennis-bots',
  'rocket-league-bots',
  'ecricket',
]);

const valuesDisplayingSettlementRules: (string | undefined)[] = ['special'];

const esportDisciplines = [
  'csgo',
  'dota2',
  'lol',
  'artifact',
  'pubg',
  'hs',
  'ow',
  'sc2',
  'apex',
  'hots',
  'ebasketball',
  'etennis',
  'ehockey',
  'emma',
  'call-of-duty',
  'valorant',
  'rocket-league',
  'rainbow6',
  'efootball',
  'efootball-bots',
  'ebasketball-bots',
  'etennis-bots',
  'rocket-league-bots',
  'warcraft3',
  'king-of-glory',
  'arena-of-valor',
  'efighting-bots',
  'mobile-legends',
  'ecricket',
  'free-fire',
  'crossfire',
  'fortnite',
];

const disciplineIds = [
  'csgo',
  'dota2',
  'lol',
  'fifa',
  'pubg',
  'sc2',
  'hs',
  'ow',
  'football',
  'baseball',
  'basketball',
  'basketball3x3',
  'boxing',
  'handball',
  'hockey',
  'tabletennis',
  'tennis',
  'ufc',
  'volleyball',
  'apex',
  'ebasketball',
  'etennis',
  'ehockey',
  'emma',
  'call-of-duty',
  'rocket-league',
  'rainbow6',
  'american-football',
  'rugby-league',
  'rugby-union',
  'warcraft3',
  'futsal',
  'snooker',
  'valorant',
  'efootball',
  'mma',
  'cricket',
  'efootball-bots',
  'ebasketball-bots',
  'etennis-bots',
  'rocket-league-bots',
  'king-of-glory',
  'arena-of-valor',
  'efighting-bots',
  'formula1',
  'politics',
  'horse-racing',
  'harness-racing',
  'greyhound-racing',
  'biathlon',
  'darts',
  'badminton',
  'entertainment',
  'mobile-legends',
  'aussie-rules',
  'waterpolo',
  'kabaddi',
  'beach-volleyball',
  'bowls',
  'ecricket',
  'golf',
  'power-slap',
  'crossfire',
  'fortnite',
  'lacrosse',
  'cycling',
  'chess',
] as const;

const disciplineIdsSet = new Set(disciplineIds);

const disciplineIdsWithOverTime = new Set([
  'basketball',
  'basketball3x3',
  'ebasketball',
  'american-football',
  'baseball',
  'hockey',
]);

// TODO: When adding a new discipline, you need to indicate it here so that the rules of this discipline
//  are displayed on the terms_and_conditions page. Field name = did,
//  field value is the name of the html file in the directory src/translates/static/
const termsAndConditionsDisciplinesAliases = {
  csgo: 'CSGO',
  dota2: 'Dota 2',
  hs: 'Hearthstone',
  lol: 'League of Legends',
  fifa: 'eFootball',
  pubg: 'PUBG',
  sc2: 'StarCraft II',
  football: 'Football',
  baseball: 'Baseball',
  basketball: 'Basketball',
  // 'basketball3x3': 'Basketball',
  boxing: 'Boxing',
  handball: 'Handball',
  hockey: 'Hockey',
  tabletennis: 'Table Tennis',
  tennis: 'Tennis',
  ufc: 'eMMA',
  volleyball: 'Volleyball',
  ebasketball: 'eBasketball',
  etennis: 'eTennis',
  ehockey: 'eHockey',
  emma: 'eMMA',
  'call-of-duty': 'Call of Duty',
  'rocket-league': 'Rocket League',
  rainbow6: 'Rainbow 6',
  'american-football': 'American football',
  'rugby-league': 'Rugby League',
  'rugby-union': 'Rugby Union',
  warcraft3: 'Warcraft',
  futsal: 'Futsal',
  snooker: 'Snooker',
  valorant: 'Valorant',
  efootball: 'eFootball',
  mma: 'MMA',
  cricket: 'Cricket',
  'efootball-bots': 'eFootball Bots',
  'ebasketball-bots': 'eBasketball Bots',
  'etennis-bots': 'eTennis Bots',
  'rocket-league-bots': 'Rocket League Bots',
  'king-of-glory': 'King of Glory',
  'arena-of-valor': 'Arena of Valor',
  overwatch: 'Overwatch',
  'efighting-bots': 'eFighting',
  formula1: 'Formula 1',
  'horse-racing': 'Horse Racing',
  badminton: 'Badminton',
  biathlon: 'Biathlon',
  'aussie-rules': 'Aussie rules',
  'beach-volleyball': 'beach-volleyball',
  bowls: 'bowls',
  darts: 'Darts',
  ecricket: 'ecricket',
  golf: 'Golf',
  kabaddi: 'kabaddi',
  waterpolo: 'waterpolo',
  'mobile-legends': 'Mobile Legends',
  'free-fire': 'Garena Free Fire',
  'power-slap': 'Power Slap',
  crossfire: 'Crossfire',
  fortnite: 'Fortnite',
  lacrosse: 'Lacrosse',
  cycling: 'Cycling',
  chess: 'Chess',
  apex: 'Apex Legends',
};

const defaultOddsFormat = 'decimal';
const oddsFormats = {
  decimal: 'DECIMAL',
  american: 'AMERICAN',
  fractional: 'FRACTIONAL',
  hongKong: 'HONG_KONG',
  malaysian: 'MALAYSIAN',
  indonesian: 'INDONESIAN',
};

const customOddsFormats = {
  decimal: 'DECIMAL',
  fractional: 'FRACTIONAL',
  hongKong: 'HONG_KONG',
  malaysian: 'MALAYSIAN',
};

const partnerCidsCustomOddsFormats = ['ta-okhash-eu', 'ta-okhash-asia'];

const entityNames = {
  line: 'lines',
  discipline: 'disciplines',
  tournament: 'tournaments',
  event: 'events',
  market: 'markets',
  scoreboard: 'scoreboards',
} as const;
export type UEntityName = keyof typeof entityNames;

const rpcTypes = ['search', 'topTournaments', 'disciplineSummary'] as const;

const disciplinesWithChat = ['dota2', 'csgo'];

const marketsKindsWithShortName = [3, 7];

const internationalTournamentsIds = [3, 4, 5, 6, 7, 8, 9, 157, 162, 198, 201];

const mainMarketsNames = [
  'ES.MARKETS.RESULT_OF_THE_MATCH',
  'ES.MARKETS.HANDICAP',
  'COMMON.MARKET.TOTAL',
  'COMMON.MARKET.DOUBLECHANCES',
  'COMMON.MARKET.ASIAN_HANDICAP',
  'COMMON.MARKET.ASIAN_TOTAL',
];

const mainMarketsNamesWithOvertime = [
  'COMMON.MARKETS.WINNER_WITH_OVERTIME',
  'COMMON.MARKETS.HANDICAP_WITH_OVERTIME',
  'COMMON.MARKETS.TOTAL_WITH_OVERTIME',
];

const fullLine = ['5', '4', '2', '1'];
const livePrematchLine = ['2', '1'];
const topEventsLine = ['5', '4'];
const topEventsLines = new Set(topEventsLine);
const liveFullLine = ['5', '2'];
const liveLines = new Set(liveFullLine);
const prematchFullLine = ['4', '1'];
const prematchLine = ['1'];
const outrightLine = ['1', 'outright'];
const minTopIndexForTopEvents = 90;

const currencySigns = {
  usd: '$',
  eur: '€',
  uah: '₴',
  rur: '₽',
  rub: '₽',
};

const cryptoCurrencies = ['uETH', 'mWBTC', 'uWBTC', 'mBTC', 'uBTC', 'kTHING'];

const intervals = ['past', '', 'tomorrow', 'live'];

const defaultLanguage = 'en';
const rtlLanguages = ['ku', 'ar', 'fa'];
const viewTypesSettings = {
  european: {
    locale: 'en',
    oddsFormat: {
      type: 'decimal',
      slug: 'DECIMAL',
    },
  },
  american: {
    locale: 'en-us',
    oddsFormat: {
      type: 'american',
      slug: 'AMERICAN',
    },
  },
  social: {
    locale: 'en-soc',
    oddsFormat: {
      type: 'american',
      slug: 'AMERICAN',
    },
  },
};
const languagesISO = [
  'en',
  'en-us',
  'ru',
  'uk',
  'zh',
  'ja',
  'fr',
  'de',
  'pt',
  'en-soc',
  'es',
  'tr',
  'kk',
  'th',
  'ko',
  'et',
  'lt',
  'lv',
  'ku',
  'nl',
  'uz',
  'ar',
  'id',
  'fa',
  'sq',
  'bn',
  'ms',
  'az',
];
const languages = [
  'en',
  'en-us',
  'ru',
  'uk',
  'zh',
  'ja',
  'fr',
  'de',
  'pt',
  'en-soc',
  'es',
  'tr',
  'kk',
  'th',
  'ko',
  'et',
  'lt',
  'lv',
  'ku',
  'nl',
  'uz',
  'ar',
  'id',
  'fa',
  'sq',
  'bn',
  'ms',
  'az',
];
const languagesTranslated = {
  en: 'English',
  'en-us': 'American',
  ru: 'Русский',
  uk: 'Українська',
  zh: '中国語',
  ja: '日本語',
  fr: 'Française',
  de: 'Deutsch',
  pt: 'Portuguesa',
  'en-soc': 'Social',
  es: 'Española',
  tr: 'Türk',
  kk: 'Қазақ',
  th: 'ภาษาไทย',
  ko: '한국어',
  et: 'Eesti',
  lt: 'Lietuvių kalba',
  lv: 'Latvietis',
  ku: 'Kurdî',
  nl: 'Nederlands',
  uz: "O'zbek tili",
  ar: 'اللغة العربية',
  id: 'Bahasa Indo',
  fa: 'فارسی',
  sq: 'Gjuha shqipe',
  bn: 'Bengali',
  ms: 'Malay',
  az: 'Azərbaycan dili',
};

function getISOLang(lang: string) {
  return languagesISO[languages.findIndex((l) => lang === l)];
}

function getLocaleLang(lang = defaultLanguage) {
  let currentLang = lang || defaultLanguage;
  let currentLangIndex = languagesISO.findIndex((l) => currentLang === l);

  if (currentLangIndex === -1 && currentLang.includes('-')) {
    currentLang = currentLang.split('-')[0] ?? defaultLanguage;
    currentLangIndex = languagesISO.findIndex((l) => currentLang === l);
  }
  return languages[currentLangIndex] || defaultLanguage;
}

const currencies = {
  100: 'usd',
  102: 'eur',
  103: 'uah',
  104: 'rur',
};

const betslipTabs = ['SINGLEBET', 'QUICK-BETS', 'EXPRESS'];

const widgetTabs = [
  {
    id: 'betslip',
    title: 'BETSLIP.BETSLIP',
  },
  {
    id: 'mybets',
    title: 'ES.COMMON.MY_BETS',
    badge: 4,
  },
  {
    id: 'chat',
    title: 'ES.COMMON.CHAT',
  },
  {
    id: 'turbo-combo',
    title: 'COMMON.TURBO_COMBO',
  },
  {
    id: 'slots',
    title: 'ES.COMMON.SPIN_AND_WIN',
  },
];

const mybetTabs = ['unsettled', 'settled'];

const couponTabs = [
  {
    id: 'live',
    title: 'Live',
  },
  {
    id: 'single',
    title: 'Single',
  },
  {
    id: 'combo',
    title: 'Combo',
  },
];

const topCountriesByCids = [
  {
    brand: 'hero-ta-stage',
    countriesCode: ['JP'],
  },
  {
    brand: 'taracing-herogaming',
    countriesCode: ['JP'],
  },
];

const widgetLeaderboardsPlace: { [key: string]: number } = {
  destinyx: 2,
};

const defaultSortingByTournaments = ['ta-tp-tetherbet'];

const expressInputId = 'comboMaxBet';
const turboComboInputId: string = 'betslip-turbo-combo';
const liveInputId: string = 'betslip-live-bet';

const bannerZones = {
  widgetTopEvents: 'section_1',
  rightColumn: 'section_3',
};

// TODO: TMP while backend is not ready
const justForYouBlockTournamentIds = new Set([
  '1',
  '100',
  '103',
  '11',
  '11879',
  '22',
  '41',
  '7060',
  '7061',
  '7062',
  '7063',
  '72',
  '7268',
  '7633',
  '97',
  '9980',
  '27',
]);

export {
  ERROR_AUTO_CLEAR_TIMEOUT,
  expressMaxOdd,
  disciplineViewTypes,
  disciplineIds,
  footballDisciplines,
  vsportDisciplines,
  currencySigns,
  defaultOddsFormat,
  oddsFormats,
  customOddsFormats,
  partnerCidsCustomOddsFormats,
  fullLine,
  livePrematchLine,
  topEventsLine,
  topEventsLines,
  liveLines,
  intervals,
  lineFilterToDisciplineCategories,
  languages,
  rtlLanguages,
  languagesISO,
  languagesTranslated,
  getISOLang,
  getLocaleLang,
  defaultLanguage,
  betslipTabs,
  currencies,
  widgetTabs,
  mybetTabs,
  couponTabs,
  disciplinesWithChat,
  entityNames,
  esportDisciplines,
  animalsRacingDisciplines,
  pureOutrightsDisciplines,
  termsAndConditionsDisciplinesAliases,
  marketsKindsWithShortName,
  customTournamentPageId,
  footballWorldCupEventsIds,
  customTournamentPageOutrightIds,
  footballWorldCupViewTypes,
  customTournamentPageSlug,
  customTournamentPageDid,
  customTournamentPageRoute,
  fakeDemoPartnerCids,
  topCountriesByCids,
  isDemoLocation,
  socketBatchActions,
  minBoostOdd,
  cryptoCurrencies,
  valuesDisplayingSettlementRules,
  internationalTournamentsIds,
  mainMarketsNames,
  mainMarketsNamesWithOvertime,
  navMenuCustomTournament,
  navMenuCustomTournamentLink,
  widgetLeaderboardsPlace,
  minTopIndexForTopEvents,
  liveFullLine,
  prematchFullLine,
  prematchLine,
  outrightLine,
  subscribeChain,
  betTrackMark,
  defaultSortingByTournaments,
  customTournamentPageName,
  customTournamentPageLivePrematchLine,
  customTournamentPageStats,
  customTournamentPageHeaderTitle,
  customTournamentPageMenuTabName,
  isShowOlympicGamesPage,
  olympicGamesPageTitle,
  olympicGamesPageName,
  olympicGamesTournamentsIdsForDisciplines,
  additionalDisciplinesForOlympicGames,
  expressInputId,
  olympicGamesTournamentFilterLS,
  olympicGamesLineFilterLS,
  isShowTopCustomTournamentPage,
  topCustomTournamentPageId,
  topCustomTournamentPageOutrightIds,
  topCustomTournamentPageDid,
  topCustomTournamentPageName,
  topCustomTournamentPageHeaderTitle,
  topCustomTournamentPageMenuTabName,
  topCustomTournamentPageRoute,
  topCustomTournamentPageIconName,
  topCustomTournamentPageHeaderDiscipline,
  viewTypesSettings,
  bannerZones,
  justForYouBlockTournamentIds,
  disciplineIdsWithOverTime,
  turboComboInputId,
  liveInputId,
  shadowRootModePrefix,
  rpcTypes,
  disciplineCategoryAliases,
  disciplineIdsSet,
  PLACE_BET_DEBOUNCE_TIME,
  defaultFontURL,
};
